'use strict';

import React, { Component } from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import Layout from '@Layout/BackOffice'

import _ from 'lodash'

import { form as config } from '@Config/EC/EC'

import UpdateForm from '@/Form/UpdateForm'

import DatePicker from '@/Form/V2/DatePicker'

import AbondementAddedHistory from '@/Abondement/AbondementAddedHistory'

import ECStats from '@/ECStats'

import Loader from '@Pure/Loader'
import Link   from '@Pure/Link'

const { app, moment } = window;

function getInitialState (component)
{
	if (app.state.session?.permissions?.title !== 'Membre de synergies')
	{
		return { init: false };
	}

	const id = document.location.pathname
	.slice(document.location.pathname.lastIndexOf('/')+1);

	if (!id) return { init: false, error: 'Page invalide.' };

	const state =
	{
		form_data:
		{
			start: moment().startOf('month').format('YYYY-MM-DD'),
			end: moment().endOf('month').format('YYYY-MM-DD')
		},

		init: true,
		deleted: false,

		EC_id: id,

		status_messages: { }
	};

	const form_config = _.cloneDeep(config);

	form_config.can_delete = true;

	form_config.fields = _.assign(
	{
		code:
		{
			label: 'Code',
			readOnly: true
		}
	},
	form_config.fields);

	state.form_config = form_config;

	return state;
}

export default class ECPage extends Component
{
	state = getInitialState(this);

	UNSAFE_componentWillMount ()
	{
		app.resetFunctions();
	}

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		if (state.init !== true)
		{
			const update = getInitialState(component);

			if (update.init) { return component.setState(update); }
		}

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = () =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.init) return; // already initialized

		component.setState(getInitialState(component));
	}

	handleDateChange = ({ e, value, name }) =>
	{
		const component = this, props = this.props, state = this.state;

		delete state.status_messages[name];

		state.form_data[name] = value;

		component.setState(
		{
			form_data: state.form_data,
			status_messages: state.status_messages
		});
	}

	handleDeletion = () => this.setState({ deleted: true });

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const { start, end } = state.form_data || { };

		const export_by_theme = state.init ?
		(
			<div className="o-grid-3">

				<div className="o-grid__item u-flex u-items-start u-gap-15">

					<DatePicker name="start" label="Du" inline
						onChange={ component.handleDateChange }
						value={ state.form_data.start }
					/>

					<DatePicker name="end" label="Au" inline
						onChange={ component.handleDateChange }
						value={ state.form_data.end }
					/>

				</div>

				<div className="o-grid__item u-flex u-items-end">

					<a className="c-btn c-btn--extra"
						href={ '/export/commandes-par-theme?debut=' + start
						+ '&fin=' + end + '&structure=' + state.EC_id }
						target="_blank" rel="noreferrer" type="text/csv">
						Télécharger
					</a>

				</div>

			</div>
		)
		: undefined;

		const form = state.init ?
		(
			<UpdateForm config={ state.form_config }
				onDelete={ component.handleDeletion }
			/>
		)
		: undefined;

		const fetching = state.init !== true ?
		(
			<div className="u-full-width u-padding-top-30 u-padding-bottom-30">
				<Loader className="c-loader" bemit={ ['primary', 'bg-white'] }
					text="Chargement..."
				/>
			</div>
		)
		: undefined;

		return (
			<Layout page_title="Fiche d'un Comité d'Entreprise"
				history={ props.history }>

				<div className="page-content">

					<div className="o-content u-positioned">

						{ fetching }

						{ form }

						{
							state.deleted !== true && state.init ?
							(
								<>

									<div className="u-text-right u-margin-top-30">
										<Link className="c-btn c-btn--extra"
											href={ '/gestion-des-CE/abondements-CE/' + state.EC_id }>
											Ajouter de l'abondement au CE
										</Link>
									</div>

									<div className="u-margin-top-20">
										<AbondementAddedHistory
											EC_id={ state.EC_id }
										/>
									</div>

									<div className="c-form u-positioned">

										<div className="c-title c-title--form">
											<div className="c-title__txt">
												Export des commandes par thème
											</div>
										</div>

										{ export_by_theme }

									</div>

									<ECStats id={ state.EC_id } />

								</>
							)
							: undefined
						}

					</div>

				</div>

			</Layout>
		);
	}
}